class SHTVariantSelector extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);

    this.elms = {
      radio_elms: this.$$(".js-variant-radio-item"),
      radio_container_elms: this.$$(".js-variant-radio-container"),
      form: SHTHelper.qs(`#productForm-${this.dataset.section}`),
      price: SHTHelper.qs(`#productPrice-${this.dataset.section}`),
      installment_form: SHTHelper.qs(`#productFormInstallment-${this.dataset.section}`),
      product_form: SHTHelper.qs(`sht-prd-frm[data-section="${this.dataset.section}"]`),
      inventory_tracking: SHTHelper.qs(`#inventoryTracking-${this.dataset.section}`),
      sku: SHTHelper.qs(`#sku-${this.dataset.section}`),
      variant_picker: SHTHelper.qs(`#variantPicker-${this.dataset.section}`),
      quantity_input: SHTHelper.qs(`#productQuantity-${this.dataset.section}`),
      slideshow: SHTHelper.qs(`sht-prd-slideshow[data-section="${this.dataset.section}"]`),
      thumb_carousel: SHTHelper.qs(`sht-vert-carousel[data-section="${this.dataset.section}"]`),
      product_sticky_info: SHTHelper.qs(`#productStickyInfo-product-sticky-bar`),
      carousel: SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`),
      variant_options: this.$$(".js-variant-option-value"),
      input_id_form_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-sticky-form-input-id"),
      form_sticky: SHTHelper.qs("sht-prd-frm-sticky"),
    };

    this.price_selector = `#productPrice-${this.dataset.section}`;
    this.inventory_tracking_selector = `#inventoryTracking-${this.dataset.section}`;
    this.sku_selector = `#sku-${this.dataset.section}`;
    this.variant_picker_selector = `#variantPicker-${this.dataset.section}`;
    this.quantity_input_selector = `#productQuantity-${this.dataset.section}`;
    this.slideshow_selector = `sht-prd-slideshow[data-section="${this.dataset.section}"]`;

    this.variantData = this.setSelectedVariants(this);

    this.updateProductStickyInfo(this.variantData);
    this.updateSelectedVariants(this.variantData);
    this.bindEventHandlers();
  }

  setSelectedVariants(node) {
    return JSON.parse(node.querySelector('[data-selected-variant][type="application/json"]').textContent);
  }

  connectedCallback() {
    this.init();
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.addEventListener("change", this.onVariantChangeHandle.bind(this));
  }

  onVariantChangeHandle() {
    this.toggleAddButton(true);
    this.removeErrorMessage();
    this.renderProductInfo();
  }

  updateProductStickyInfo(variant) {
    if (this.elms.product_sticky_info) {
      this.elms.product_sticky_info.querySelector(".js-product-sticky-info-variant").innerHTML = variant.title;
      if (this.elms.price) {
        this.elms.product_sticky_info.querySelector(".js-product-sticky-info-price").innerHTML = this.elms.price.innerHTML;
      }
      this.elms.product_sticky_info.querySelector(".js-quantity-input").value = 1;

      this.elms.product_sticky_info.querySelector(`[name="id"]`).value = variant.id;
    }
  }

  removeErrorMessage() {
    if (this.elms.product_form) this.elms.product_form.handleErrorMessage();
  }

  updatePickupAvailability(variant) {
    const pickUpAvailability = SHTHelper.qs("sht-pickup-avail");
    if (!pickUpAvailability) return;

    if (variant && variant.available) {
      pickUpAvailability.fetchAvailability(variant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.classList.remove("d-block");
      pickUpAvailability.classList.add("d-none");
      pickUpAvailability.innerHTML = "";
    }
  }

  getSelectedVariantValue() {
    return Array.from(this.querySelectorAll('.js-variant-item:checked')).map(el => el.dataset.optionValueId);
  }

  buildRequestUrlWithParams(url, optionValues) {
    const params = new URLSearchParams({ section_id: this.dataset.section });
    if (optionValues.length) params.append("option_values", optionValues.join(","));
    return `${url}?${params.toString()}`;
  }

  async renderProductInfo() {
    const productUrl = this.dataset.url;
    const optionValues = this.getSelectedVariantValue();
    const requestUrl = this.buildRequestUrlWithParams(productUrl, optionValues);

    try {
      const response = await fetch(requestUrl);
      if (!response.ok) throw new Error("Network response was not ok");

      const html = await response.text();
      const markup = new DOMParser().parseFromString(html, "text/html");

      const variant = this.setSelectedVariants(markup);

      if (!variant) return this.setUnavailable();

      this.updateUI(markup, variant);
    } catch (err) {
      console.error("Error fetching product info:", err);
      this.setUnavailable();
    }
  }

  checkInventory(markup) {
    const dest = this.elms.inventory_tracking;
    const src = markup.querySelector(this.inventory_tracking_selector);
    if (dest) dest.innerHTML = src?.innerHTML ?? "";
  }

  updateUI(markup, variant) {
    this.updatePickupAvailability(variant);
    this.checkInventory(markup);
    this.updateVariantInput(variant);
    this.updateOptionValues(markup);

    this.updateURL(variant);

    this.setActiveMedia(variant);
    this.updatePrice(markup);
    this.updateSku(markup);
    this.updateQuantity(markup);
    this.updateProductStickyInfo(variant);
    this.updateSelectOptions(markup, variant);
    this.updateSlideshow(markup);
    this.updateAddToCartState(variant);
  }

  updateAddToCartState(variant) {
    this.toggleAddButton(!variant.available, SHTLanguage.product.PRODUCT_SOLD_OUT);
    this.toggleAddButtonSticky(!variant.available, SHTLanguage.product.PRODUCT_SOLD_OUT);
  }

  updateSlideshow(markup) {
    if (this.elms.slideshow?.hide_variant === "false") {
      const src = markup.querySelector(this.slideshow_selector);
      if (src && this.elms.slideshow) {
        this.elms.slideshow.innerHTML = src.innerHTML;
        this.elms.slideshow.bindEventHandlers();
      }
    }
  }

  updateSelectedVariants(variant) {
    if (!variant?.options) return;

    variant.options.forEach((e, index) => {
      const variantValue = `${e}-${index}`.replace(/"/g, '\\"');
      const selectedElement = this.$(`.js-variant-item[data-variant-value="${variantValue}"]`);
      if (selectedElement) {
        const variantName = selectedElement.getAttribute("data-variant-name") || selectedElement.getAttribute("name");
        const optionValue = selectedElement.dataset.optionVariantValue;
        if (variantName) {
          const targetElement = this.$(`.js-variant-radio-option-name[data-option-name="${variantName.replace(/"/g, '\\"')}"]`);
          if (targetElement) targetElement.innerHTML = e;

          const targetSelectElement = this.$(`.js-variant-select-option-name[data-option-name="${variantName.replace(/"/g, '\\"')}"]`);
          if (targetSelectElement) {
            targetSelectElement.innerHTML = optionValue || e;
          }
        }
      }
    });
  }

  updateSelectOptions(markup, variant) {
    const srcItems = markup.querySelectorAll('sht-select .js-variant-select-item');
    const destItems = this.querySelectorAll('sht-select .js-variant-select-item');
    srcItems.forEach((src, i) => {
      if (destItems[i]) destItems[i].innerHTML = src.innerHTML;
    });
    this.updateSelectedVariants(variant);
  }

  updatePrice(markup) {
    const src = markup.querySelector(this.price_selector);
    if (src && this.elms.price) {
      this.elms.price.innerHTML = src.innerHTML;
      this.elms.price.classList.remove("d-none-important");
    }
  }

  updateQuantity(markup) {
    const msgDest = this.elms.quantity_input?.querySelector('.js-max-quantity-message');
    const msgSrc = markup.querySelector(this.quantity_input_selector)?.querySelector('.js-max-quantity-message');
    if (msgDest) {
      msgDest.classList.add('d-none-important');
      msgDest.innerHTML = msgSrc?.innerHTML ?? "";
    }
    const inputSrc = markup.querySelector(this.quantity_input_selector);
    if (this.elms.quantity_input) this.elms.quantity_input.innerHTML = inputSrc?.innerHTML ?? "";
  }

  updateSku(markup) {
    const src = markup.querySelector(this.sku_selector);
    if (this.elms.sku) this.elms.sku.innerHTML = src?.innerHTML ?? "";
  }

  updateOptionValues(markup) {
    const src = markup.querySelector('.product-details .js-variant-picker');
    const dest = this.elms.variant_picker;
    if (src && dest) dest.innerHTML = src.innerHTML;
  }

  updateURL(variant) {
    if (!variant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${variant.id}`);
  }

  updateVariantInput(variant) {
    if (!variant) return;
    const forms = [this.elms.form, this.elms.installment_form];
    const stockStatus = SHTHelper.qs('.js-inventory-tracking');
    stockStatus?.classList.remove('d-none');
    forms.forEach(f => {
      if (f) {
        const input = f.querySelector('input[name="id"]');
        console.log(input);
        if (input) {
          input.value = variant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    });
  }

  setActiveMedia(variant) {
    if (variant.featured_media) {
      let mediaId = variant.featured_media.id;

      let activeMedia = this.elms.slideshow.querySelector(`sht-carousel-itm[data-media-id="${this.dataset.section}-${mediaId}"]`);

      let activeThumb = this.elms.slideshow.querySelector(`sht-vert-carousel-itm[data-media-target-id="${this.dataset.section}-${mediaId}"]`);

      if (!window.matchMedia("(max-width: 768px)").matches) {
        this.elms.slideshow.querySelectorAll(".js-product-slideshow-item").forEach(element => {
          element.classList.remove("d-block");
          this.elms.slideshow.hide_variant == "true" && element.classList.add("d-none");
        });

        this.elms.slideshow.querySelectorAll(".js-product-slideshow-thumb").forEach(element => {
          element.classList.remove("is-active-item");
        });

        activeMedia.classList.add("d-block");
        if (this.elms.slideshow.hide_variant == "true") {
          activeMedia.classList.remove("d-none");
        }

        if (activeThumb) {
          activeThumb.classList.add("is-active-item");
          this.elms.thumb_carousel.querySelector(".js-carousel-items").scrollTo({
            top: activeThumb.offsetTop,
            behavior: "auto",
          });
        }
      } else {
        this.elms.slideshow.querySelectorAll(".js-product-slideshow-thumb").forEach(element => {
          element.classList.remove("is-active-item");
        });

        this.elms.carousel.querySelector(".js-carousel-items").scrollTo({
          left: activeMedia.offsetLeft,
          behavior: "smooth",
        });

        if (activeThumb) {
          activeThumb.classList.add("is-active-item");
          this.elms.thumb_carousel.querySelector(".js-carousel-items").scrollTo({
            left: activeThumb.offsetLeft,
            behavior: "auto",
          });
        }
      }

      this.elms.slideshow.pauseAllVideo();
    }
  }

  setUnavailable() {
    let form = this.elms.form;
    let inventoryTracking = this.elms.inventory_tracking;
    if (!form) return;
    let addBtn = form.querySelector(".js-product-form-submit-btn");
    let addBtnText = addBtn.querySelector(".js-product-form-submit-btn-text");
    if (!addBtn) return;
    if (inventoryTracking) inventoryTracking.classList.add("d-none");
    addBtnText.textContent = SHTLanguage.product.PRODUCT_UNAVAILABLE;
    if (this.elms.price) this.elms.price.classList.add("visibility-hidden");

    if (this.elms.input_id_form_sticky) {
      this.elms.input_id_form_sticky.value = "";
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let form = this.elms.form;

    if (!form) return;
    let addBtn = form.querySelector(".js-product-form-submit-btn");
    let addBtnText = addBtn?.querySelector(".js-product-form-submit-btn-text");

    if (!addBtn) return;

    if (disable) {
      addBtn.setAttribute("disabled", "disabled");
      if (text) addBtnText.textContent = text;
    } else {
      addBtn.removeAttribute("disabled");
      addBtnText.textContent = SHTLanguage.product.PRODUCT_ADD_TO_CART;
    }

    if (!modifyClass) return;
  }

  toggleAddButtonSticky(disable = true, text, modifyClass = true) {
    let form = this.elms.form_sticky;

    if (!form) return;
    let addBtn = form?.querySelector(`.js-product-form-submit-btn`);
    let addBtnText = addBtn?.querySelector(`.js-product-form-submit-btn-text`);

    if (disable) {
      if (text) addBtnText.textContent = text;
    } else {
      addBtnText.textContent = SHTLanguage.product.PRODUCT_ADD_TO_CART;
    }
    if (this.elms.inventory_tracking) this.elms.inventory_tracking.classList.remove("d-block");

    form.querySelectorAll(`button, [role="button"]`).forEach(e => {
      if (disable) {
        e.setAttribute("disabled", "disabled");
        e.style.pointerEvents = "none";
      } else {
        e.removeAttribute("disabled");
        e.style.pointerEvents = "auto";
      }
    });
    if (!modifyClass) return;
  }

}

class SHTVariantRadios extends SHTVariantSelector {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.select_type = "button";
  }

}

customElements.define("sht-variant-radios", SHTVariantRadios);

class SHTVariantSelects extends SHTVariantSelector {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.select_type = "dropdown";
  }
}
customElements.define("sht-variant-selects", SHTVariantSelects);
class SHTVariantSwatchSelect extends HTMLElement {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
  }

  init() {
    this.radios = this.$$(".js-variant-radio-item");
    this.select_id = this.dataset.selectId;
    this.select_element = document.querySelector(`#${this.select_id}`);

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.radios.forEach(radio => {
      radio.addEventListener("click", e => {
        e.preventDefault();
        Array.from(this.radios, input => {
          input.checked = false;
        });

        setTimeout(() => {
          e.target.checked = true;
        });
        if (this.select_element) {
          let option = this.select_element.querySelector(`option[value="${e.target.value.replace(/"/g, '\\"')}"]`);
          option.selected = true;
          this.select_element.dispatchEvent(
            new Event("change", {
              bubbles: true,
            })
          );
        }
      });
    });
  }
  connectedCallback() {
    this.init();
  }
}
customElements.define("sht-variant-swatch-select", SHTVariantSwatchSelect);

class SHTProductForm extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.elms = {
      form: this.$("form"),
      submit_btn: this.$('[type="submit"]'),
      error_wrapper: this.$(".js-product-form-error-wrapper"),
      error_message: this.$(".js-product-form-error-message"),
      spinner: this.$(".js-product-form-spinner"),
      quantity_input_container: SHTHelper.qs(`#productQuantity-${this.dataset.section}`),
      submit_btn_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-submit-btn"),
      error_wrapper_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-error-wrapper"),
      error_message_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-error-message"),
      spinner_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-spinner"),
      sticky_header: SHTHelper.qs("sht-sticky-header"),
      announcement_bar: SHTHelper.qs("sht-ann-bar"),
      header_cart_status: SHTHelper.qs("#headerCartStatus"),
    };

    this.elms.form.querySelector("[name=id]").disabled = false;

    this.cartNotification = SHTHelper.qs("sht-cart-noti");

    this.cartDrawer = SHTHelper.qs("sht-cart-drwr");
    this.cartDrawerForm = SHTHelper.qs("sht-cart-drwr-frm");
    this.cardRecipientForm = SHTHelper.qs("sht-gift-card-recipient-form");
    this.bindEventHandlers();
  }

  connectedCallback() {
    this.init();
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    // this.cartNotification &&
    //   this.cartNotification.setActiveElement(document.activeElement);
  }

  onSubmitHandler(e) {
    e.preventDefault();

    if (this.elms.submit_btn.classList.contains("loading")) return;
    this.hideErrorMessage();

    this.elms.submit_btn.setAttribute("aria-disabled", true);
    this.elms.submit_btn.setAttribute("disabled", true);
    this.elms.submit_btn.classList.add("loading");

    if (this.elms.submit_btn_sticky) {
      this.elms.submit_btn_sticky.setAttribute("aria-disabled", true);
      this.elms.submit_btn_sticky.setAttribute("disabled", true);
      this.elms.submit_btn_sticky.classList.add("loading");
    }

    // this.elms.spinner.classList.remove("hidden");
    if (this.elms.spinner_sticky) {
      this.elms.spinner_sticky.classList.remove("hidden");
    }
    if (this.elms.header_cart_status) {
      this.elms.header_cart_status.classList.remove("header-cart-status--animate");
    }

    let sections = this.cartNotification.getSectionsToRender();
    if (this.cartDrawer) {
      sections = [...sections, ...this.cartDrawer.getSectionsToRender()];
    }

    let formData = new FormData(this.elms.form);
    formData.append(
      "sections",
      sections.map(section => section.id)
    );
    formData.append("sections_url", window.location.pathname);
    SHTHelper.fetchConfigHTTP.body = formData;

    fetch(`${routes.cart_add_url}`, SHTHelper.fetchConfigHTTP)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          this.handleErrorMessage(response.description, response?.message);
          return;
        }
        if (!response.id) {
          response.id = formData.get("id");
        }

        // if (this.elms.sticky_header) {
        //   if (this.elms.sticky_header.dataset.isEnabled) {
        //     this.elms.sticky_header.reveal();
        //   }
        // }
        if (this.cartNotification) {
          this.cartNotification.renderContents(response);
        }
        if (this.cartDrawerForm) {
          this.cartDrawerForm.renderContents(response);
        }

        if (this.elms.quantity_input_container && this.elms.quantity_input_container.dataset.show == "add-to-cart") {
          this.elms.quantity_input_container.classList.remove("d-none");
          this.elms.quantity_input_container.querySelector("input").value = 1;
        }

        if (this.cardRecipientForm) {
          this.cardRecipientForm.resetRecipientForm();
        }
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.elms.submit_btn.classList.remove("loading");
        this.elms.submit_btn.removeAttribute("aria-disabled");
        this.elms.submit_btn.removeAttribute("disabled");

        if (this.elms.submit_btn_sticky) {
          this.elms.submit_btn_sticky.classList.remove("loading");
          this.elms.submit_btn_sticky.removeAttribute("aria-disabled");
          this.elms.submit_btn_sticky.removeAttribute("disabled");
        }

        // this.elms.spinner.classList.add("hidden");
        if (this.elms.spinner_sticky) {
          this.elms.spinner_sticky.classList.add("hidden");
        }
      });
  }
  hideErrorMessage() {
    this.elms.error_wrapper.toggleAttribute("hidden", true);
    if (this.elms.error_wrapper_sticky && this.elms.error_message_sticky) {
      this.elms.error_wrapper_sticky.toggleAttribute("hidden", true);
    }
  }
  handleErrorMessage(errorMessage = false, message = "") {
    if (errorMessage) {
      if (typeof errorMessage == "string") {
        this.elms.error_wrapper.toggleAttribute("hidden", !errorMessage);

        if (this.elms.error_wrapper_sticky && this.elms.error_message_sticky) {
          this.elms.error_wrapper_sticky.toggleAttribute("hidden", !errorMessage);
        }
        this.elms.error_message.textContent = errorMessage;
        if (this.elms.error_wrapper_sticky && this.elms.error_message_sticky) {
          this.elms.error_message_sticky.textContent = errorMessage;
        }
      }

      if (this.cardRecipientForm && typeof errorMessage == "object") {
        this.cardRecipientForm.handleErrorMessage(errorMessage, message);
      }
    }
  }
}

customElements.define("sht-prd-frm", SHTProductForm);

class SHTQuantityInputSticky extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.input = this.$(`[name="quantity"]`);
    this.orgInput = SHTHelper.qs(`sht-qty-inp .js-main-product-quantity-input`);
    this.changeEvent = new Event("change", { bubbles: true });
    this.$$("button").forEach(button => button.addEventListener("click", this.onButtonClickHandle.bind(this)));

    this.orgInput.addEventListener("change", () => {
      this.input.value = this.orgInput.value;
    });
  }
  connectedCallback() {
    this.init();
  }
  onButtonClickHandle(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.dataset.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      this.orgInput.value = this.input.value;
    }
  }
}

customElements.define("sht-qty-inp-sticky", SHTQuantityInputSticky);

class SHTProductFormSticky extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.elms = {
      form: this.$("form"),
      submit_btn: this.$('[type="submit"]'),
      error_wrapper: this.$(".js-product-form-error-wrapper"),
      error_message: this.$(".js-product-form-error-message"),
      spinner: this.$(".js-product-form-spinner"),
      org_form: SHTHelper.qs(`sht-prd-frm .js-main-product-form`),
    };
    this.bindEventHandlers();
  }
  connectedCallback() {
    this.init();
  }
  bindEventHandlers() {
    this.elms.submit_btn.addEventListener("click", this.onClickSubmitButtonHandle.bind(this));

    this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(e) {
    e.preventDefault();
    return;
  }

  onClickSubmitButtonHandle() {
    this.elms.org_form.dispatchEvent(new Event("submit", { bubble: true }));
  }
}

customElements.define("sht-prd-frm-sticky", SHTProductFormSticky);

if (!customElements.get("sht-zoom")) {
  class SHTZoom extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.image = this.$(".js-zoom-item");

      this.container = SHTHelper.qs(`#${this.dataset.containerId}`);
      this.image_natural_dimension = {};
      this.container_dimension = {};
      this.rendered_aspect_ratio = {};
      this.image_dimension = {};
      this.is_able_to_zoom = true;

      this.bindEventHandlers();
    }

    init() {
      // this.getImageNaturalDimension();
      this.getImageDimension();
      this.getContainerDimension();
      let tmpSrc = this.image.src;
      let tmpSrcset = this.image.srcset;
      this.image.scr = tmpSrc;
      this.image.srcset = tmpSrcset;
      //this.calculateRenderedAspectRatio();

      // let isAbleToZoom = this.ableToZoom();
      // if (!isAbleToZoom) {
      //   this.image.style.cursor = "default";
      //   this.is_able_to_zoom = false;
      // }
      // this.bindEventHandlers();
    }

    ableToZoom() {
      if (this.rendered_aspect_ratio.container <= this.rendered_aspect_ratio.image || (this.image_natural_dimension.width <= this.container_dimension.width && this.image_natural_dimension.height <= this.container_dimension.height)) return false;

      return true;
    }

    bindEventHandlers() {
      this.image.addEventListener("click", e => {
        e.preventDefault();
        // let offsetX = 0;
        // let offsetY = 0;
        // e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
        // e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);

        let isZoomed = this.image.hasAttribute("zoomed");

        if (!isZoomed) {
          this.zoomIn();
        } else {
          this.zoomOut();
        }
      });
    }

    zoomIn() {
      const mediaQuery = window.matchMedia("(max-width: 459px)");
      this.image.style.height = "auto";
      this.image.style.objectFit = "unset";
      this.image.setAttribute("zoomed", true);
      this.image.style.cursor = "zoom-out";
      if (mediaQuery.matches) {
        this.image.style.width = "150%";
        this.image.style.maxWidth = "unset";
      } else {
        this.image.style.width = "100%";
      }

      if (this.image.offsetHeight <= this.container_dimension.height) {
        this.classList.add("d-flex", "fd-column", "center-xs");
      }
      this.container.classList.add("o-scroll");
      this.container.scrollTo({
        top: this.container.scrollHeight / 2 - this.container.offsetHeight / 2,
        behavior: "auto",
      });

      if (mediaQuery.matches) {
        this.container.scrollTo({
          left: this.container.scrollWidth / 2 - this.container.offsetWidth / 2,
          behavior: "auto",
        });
      }
    }

    zoomOut() {
      this.image.style.width = "100%";
      this.image.style.height = "100%";
      this.image.style.objectFit = "contain";
      this.image.removeAttribute("zoomed");
      this.image.style.cursor = "zoom-in";

      this.classList.remove("d-flex", "fd-column", "center-xs");
      this.container.classList.remove("o-scroll");
      this.image.style.maxWidth = null;
    }

    reset() {
      this.zoomOut();
    }

    calculateRenderedAspectRatio() {
      this.rendered_aspect_ratio = {
        image: this.image_natural_dimension.width / this.image_natural_dimension.height,
        container: this.container_dimension.width / this.container_dimension.height,
      };
    }

    getImageNaturalDimension() {
      this.image_natural_dimension = {
        width: parseInt(this.image.getAttribute("width")),
        height: parseInt(this.image.getAttribute("height")),
      };
    }

    getImageDimension() {
      this.image_dimension = {
        width: this.image.offsetWidth,
        height: this.image.offsetHeight,
      };
    }

    getContainerDimension() {
      this.container_dimension = {
        width: this.container.offsetWidth,
        height: this.container.offsetHeight,
      };
    }
  }
  customElements.define("sht-zoom", SHTZoom);
}

if (!customElements.get("sht-gallery-slide")) {
  class SHTGallerySlide extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.dialog = SHTHelper.qs(`sht-dialog#${this.dataset.galleryDialogId}`);
      this.mediaId = this.dataset.mediaId;
      this.zoomElement = this.$("sht-zoom");
      this.gallery = this.closest("sht-gallery");
    }

    init() {
      this.dialog.addEventListener("closing", e => {
        this.classList.add("d-none");
        this.classList.remove("is-active-gallery-slide", "d-flex");
        this.zoomElement && this.zoomElement.reset();
        this.gallery.pauseAllVideo();
      });
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}
  }

  customElements.define("sht-gallery-slide", SHTGallerySlide);
}

if (!customElements.get("sht-gallery-slides")) {
  class SHTGallerySlides extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.gallery = this.closest("sht-gallery");
      this.dialog = SHTHelper.qs(`sht-dialog#${this.gallery.dataset.galleryDialogId}`);
      this.slides = this.$$(".js-gallery-slide");
      this.totalSlides = this.slides.length;
      this.prevBtnElement = this.$(".js-slide-prev-btn");
      this.nextBtnElement = this.$(".js-slide-next-btn");
      this.currentSlideElement = this.$(".js-slide-current");
      this.totalElement = this.$(".js-slide-total");
      this.paginationElement = this.$(".js-slide-pagination");
      this.currentIndex = 1;
    }

    init() {
      this.dialog.addEventListener("opening", e => {
        try {
          this.slides.forEach(el => {
            if (el.dataset.mediaId == e.detail.opener.dataset.dialogMediaId) {
              el.classList.remove("d-none");
              el.classList.add("is-active-gallery-slide", "d-flex");
              let zoomElement = el.querySelector("sht-zoom");
              zoomElement && zoomElement.init();
              this.currentIndex = el.dataset.itemIndex;
              throw "done";
            }
          });
        } catch (e) {}
        this.updateNavigation();
      });

      this.bindEventHandlers();
    }

    updateNavigation() {
      this.currentSlideElement.textContent = this.currentIndex;
      this.totalElement.textContent = this.totalSlides;

      if (this.currentIndex <= 1) {
        this.prevBtnElement.setAttribute("disabled", "disabled");
      } else {
        this.prevBtnElement.removeAttribute("disabled");
      }

      if (this.currentIndex >= this.totalSlides) {
        this.nextBtnElement.setAttribute("disabled", "disabled");
      } else {
        this.nextBtnElement.removeAttribute("disabled");
      }
      if (this.totalSlides > 1) {
        this.paginationElement?.classList.remove("d-none");
        this.paginationElement?.classList.add("d-flex");
      }

      if (this.totalSlides <= 1) {
        this.paginationElement?.classList.remove("d-flex");
        this.paginationElement?.classList.add("d-none");
      }
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}

    bindEventHandlers() {
      this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this));
      this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    }

    onButtonClick(event) {
      event.preventDefault();
      let type = event.currentTarget.name.toLowerCase();
      this.showSlides(type);
    }

    showSlides(type) {
      this.currentElement = this.$(`[data-item-index="${this.currentIndex}"]`);

      if (this.currentElement) {
        let zoomElement = this.currentElement.querySelector("sht-zoom");
        zoomElement && zoomElement.reset();
      }

      this.slides.forEach(el => {
        el.classList.remove("is-active-gallery-slide", "d-flex");
        el.classList.add("d-none");
      });

      if (type === "next") {
        this.currentIndex = parseInt(this.currentIndex) + 1;
        this.currentElement = this.$(`[data-item-index="${this.currentIndex}"]`);
        this.currentElement.classList.add("is-active-gallery-slide", "d-flex");
        this.currentElement.classList.remove("d-none");
      }

      if (type === "previous") {
        this.currentIndex = parseInt(this.currentIndex) - 1;
        this.currentElement = this.$(`[data-item-index="${this.currentIndex}"]`);
        this.currentElement.classList.add("is-active-gallery-slide", "d-flex");
        this.currentElement.classList.remove("d-none");
      }
      this.currentSlideElement.textContent = this.currentIndex;
      this.updateNavigation();

      let activeZoom = this.currentElement.querySelector("sht-zoom");

      this.gallery.playActiveVideo(this.currentElement);
      this.gallery.playActiveModel(this.currentElement);
      if (activeZoom) {
        activeZoom.init();
      }
    }
  }

  customElements.define("sht-gallery-slides", SHTGallerySlides);
}

if (!customElements.get("sht-gallery")) {
  class SHTGallery extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.dialog = SHTHelper.qs(`sht-dialog#${this.dataset.galleryDialogId}`);
      this.$$(".js-gallery-btn-thumb").forEach(e => {
        e.addEventListener("click", this.setActiveMedia.bind(this, e));
      });
      this.thumbCarousel = this.$("sht-horiz-carousel");
    }

    init() {
      this.dialog.addEventListener("opening", e => {
        try {
          if (window.SHTProductMediaItemModel) {
            window.SHTProductMediaItemModel.loadShopifyXR();
          }
          this.$$(".js-gallery-thumb").forEach(el => {
            if (el.dataset.mediaTargetId == e.detail.opener.dataset.dialogMediaId) {
              el.classList.add("is-active-item");
              this.scrollToThumb(el.dataset.mediaTargetId);
              throw "done";
            }
          });
        } catch (e) {}
      });

      this.dialog.addEventListener("closing", e => {
        this.$$(".js-gallery-thumb").forEach(el => {
          el.classList.remove("is-active-item");
        });
      });
    }

    scrollToThumb(thumbId) {
      let carouselItem = this.thumbCarousel.querySelector(`[data-media-target-id="${thumbId}"]`);

      if (carouselItem) {
        this.thumbCarousel.querySelector(".js-carousel-items").scrollTo({
          left: carouselItem.offsetLeft,
          behavior: "auto",
        });
      }
    }

    setActiveMedia(e) {
      let preActiveMedia = this.$("sht-gallery-slide.is-active-gallery-slide");
      if (preActiveMedia) {
        let zoomElement = preActiveMedia.querySelector("sht-zoom");
        zoomElement && zoomElement.reset();
      }

      let activeMedia = this.$(`[data-media-id="${e.dataset.target}"]`);

      let activeZoom = activeMedia.querySelector("sht-zoom");

      let activeThumb = e.closest("sht-horiz-carousel-itm");

      this.$$(".js-gallery-slide").forEach(element => {
        element.classList.remove("is-active-gallery-slide", "d-flex");
        element.classList.add("d-none");
      });

      this.$$(".js-gallery-thumb").forEach(element => {
        element.classList.remove("is-active-item");
      });

      activeMedia.classList.add("is-active-gallery-slide", "d-flex");
      activeMedia.classList.remove("d-none");
      activeThumb.classList.add("is-active-item");

      this.playActiveVideo(activeMedia);

      this.playActiveModel(activeMedia);

      if (activeZoom) {
        activeZoom.init();
      }
    }

    pauseAllVideo() {
      this.$$(".js-media-item-youtube").forEach(video => {
        video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
      });
      this.$$(".js-media-item-vimeo").forEach(video => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });

      this.$$(".js-media-item-video").forEach(video => video.pause());
    }

    playActiveVideo(activeItem) {
      this.pauseAllVideo();
      let deferredExternalVideo = activeItem.querySelector(".js-product-media-deferred-video");

      if (deferredExternalVideo) deferredExternalVideo.loadContent();
    }

    playActiveModel(activeItem) {
      let deferredExternalModel = activeItem.querySelector(".js-product-media-deferred-model");
      if (deferredExternalModel) {
        deferredExternalModel.loadContent();
      }
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}
  }
  customElements.define("sht-gallery", SHTGallery);
}

if (!customElements.get("sht-cont-deferred")) {
  class SHTContentDeferred extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.template = this.$("template");

        if (!this.template) return;
        let content = this.template.content;
        this.appendChild(content);
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }
  }
  customElements.define("sht-cont-deferred", SHTContentDeferred);
}

if (!customElements.get("sht-pickup-avail")) {
  customElements.define(
    "sht-pickup-avail",
    class SHTPickupAvailability extends HTMLElement {
      constructor() {
        super();
        this.$ = this.querySelector.bind(this);

        if (!this.hasAttribute("available")) return;

        this.errorHtml = this.$("template").content.firstElementChild.cloneNode(true);

        this.onClickRefreshListHandleEvent = this.onClickRefreshListHandleEvent.bind(this);

        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = routes.root_url;

        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        let url = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
        fetch(url)
          .then(response => response.text())
          .then(text => {
            let sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch(e => {
            let button = this.$("button");
            if (button) button.removeEventListener("click", this.onClickRefreshListHandleEvent);
            this.renderError();
          });
      }

      onClickRefreshListHandleEvent(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);
        this.$("button").addEventListener("click", this.onClickRefreshListHandleEvent);
      }

      renderPreview(sectionInnerHTML) {
        let drawer = SHTHelper.qs("#drawerPickupAvailability");
        let preview = sectionInnerHTML.querySelector("sht-pickup-avail-prwv");

        drawer && drawer.remove();

        if (!preview) {
          this.innerHTML = "";
          this.removeAttribute("available");
          this.classList.remove("d-block");
          this.classList.add("d-none");
          return;
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute("available", "");
        this.classList.add("d-block");
        this.classList.remove("d-none");
        if (this.dataset.showExpectedPickupTime == "true") {
          sectionInnerHTML.querySelector("#drawerPickupAvailability").classList.add("pickup_availability--show-pickup-time");
        }
        document.body.appendChild(sectionInnerHTML.querySelector("#drawerPickupAvailability"));
        let button = this.$("button");
        button &&
          button.addEventListener("click", e => {
            SHTHelper.qs("#drawerPickupAvailability").openDrawer(e.target);
          });
      }
    }
  );
}

if (!customElements.get("sht-prd-recom")) {
  class SHTProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("sht-prd-recom");
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.executeScriptElements(this);
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            typeof SHTElementLazyLoad !== "undefined" && new SHTElementLazyLoad();
          });
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }

    executeScriptElements(containerElement) {
      const scriptElements = containerElement.querySelectorAll("script");

      Array.from(scriptElements).forEach(scriptElement => {
        const clonedElement = document.createElement("script");

        Array.from(scriptElement.attributes).forEach(attribute => {
          clonedElement.setAttribute(attribute.name, attribute.value);
        });

        clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

        scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
      });

      while (SHTDefer.length) SHTDefer.shift().call();
    }
  }

  customElements.define("sht-prd-recom", SHTProductRecommendations);
}

class SHTProductStickyBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.offset_height = this.offsetHeight;
    this.details = this.querySelector(".js-product-sticky-bar-details");
    this.summary = this.details?.querySelector("summary");
    this.stick_bar = SHTHelper.qs(".js-product-sticky-bar");
    this.menu_items = this.querySelector(".js-product-sticky-bar-menu-items");
    this.mobile_content = this.querySelector(".js-product-sticky-bar-mobile-content");
    this.stick_bar_bounds = {};
    this.stick_bar_offset = this.stick_bar.offsetTop;
    this.current_scroll_top = 0;
    this.bindEventHandlers();

    if (window.matchMedia("(max-width: 768px)").matches && this.mobile_content && this.menu_items) {
      this.mobile_content.innerHTML = "";
      this.mobile_content.innerHTML = this.menu_items.innerHTML;
      this.bindEventToButtonOnMobile();
    }
  }

  bindEventHandlers() {
    window.addEventListener("scroll", this.onScrollHandle.bind(this), false);
    window.addEventListener("resize", e => {
      if (this.mobile_content) {
        if (window.matchMedia("(max-width: 768px)").matches) {
          this.mobile_content.innerHTML = this.menu_items.innerHTML;
          this.bindEventToButtonOnMobile();
        } else {
          this.mobile_content.innerHTML = "";
        }
      }
    });
    this.bindEventToButtonOnDesktop();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.stick_bar_offset = this.stick_bar.offsetTop;
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(this);

    this.summary?.addEventListener("click", event => {
      event.preventDefault();
      let details = event.currentTarget.closest("details");
      event.currentTarget.setAttribute("aria-expanded", !details.open);
      if (!details.hasAttribute("open")) {
        details.open = true;

        setTimeout(() => {
          details.classList.add("is-open");
        });
      } else {
        details.classList.remove("is-open");
        setTimeout(() => {
          details.open = false;
        }, 100);
      }
    });
  }

  bindEventToButtonOnDesktop() {
    this.querySelectorAll(".js-product-sticky-bar-trigger").forEach(e => {
      e.addEventListener("click", evt => {
        evt.preventDefault();
        SHTHelper.preventStickyHeaderReveal();
        this.offset_height = this.offsetHeight;
        let menu_key = evt.target.dataset.menuKey;
        let destination = SHTHelper.qid(`${menu_key}`);

        if (destination) {
          let top = destination.offsetTop - this.offset_height;
          // SHTHelper.qid(`${menu_key}`)?.scrollIntoView({ behavior: `smooth` });
          //SHTHelper.qde.scrollTo({ top: top, behavior: `smooth` });
          SHTHelper.qde.scrollTo({ top: top, behavior: `smooth` });
        }
        this.setActiveDesktopButton(evt.target);
      });
    });
  }

  setActiveDesktopButton(current) {
    this.querySelectorAll(".js-product-sticky-bar-trigger").forEach(e => {
      e.classList.remove("sticky-nav__button--active");
    });

    current.classList.add("sticky-nav__button--active");
  }

  bindEventToButtonOnMobile() {
    this.mobile_content?.querySelectorAll(".js-product-sticky-bar-trigger").forEach(e => {
      e.addEventListener("click", evt => {
        evt.preventDefault();
        SHTHelper.preventStickyHeaderReveal();

        this.offset_height = this.offsetHeight;
        let menu_key = evt.target.dataset.menuKey;
        let destination = SHTHelper.qid(`${menu_key}`);
        if (destination) {
          let top = destination.offsetTop - this.offset_height;
          SHTHelper.qde.scrollTo({ top: top, behavior: `smooth` });
        }
        //SHTHelper.qid(`${menu_key}`)?.scrollIntoView({ behavior: `smooth` });
        this.details.open = false;
        this.setActiveMobileButton(evt.target);
      });
    });
  }

  setActiveMobileButton(current) {
    this.mobile_content?.querySelectorAll(".js-product-sticky-bar-trigger").forEach(e => {
      e.classList.remove("sticky-nav__button--active");
    });

    current.classList.add("sticky-nav__button--active");
  }
  onScrollHandle() {

    let scrollTop = window.pageYOffset || SHTHelper.qde.scrollTop;

    if (scrollTop > this.stick_bar_offset) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop < this.stick_bar_offset) {
      requestAnimationFrame(this.hide.bind(this));
    } else {
      //do nothing
    }
    this.offset_height = this.offsetHeight;
    this.current_scroll_top = scrollTop;
  }

  reveal() {
    this.stick_bar.classList.add("top-0", "animate", "zi-2", "p-sticky", "product-sticky-bar--sticky");
  }

  hide() {
    //this.stick_bar.classList.add("p-sticky", "top-0", "zi-4");
    this.stick_bar.classList.remove("product-sticky-bar--sticky");
  }
}

customElements.define("sht-product-sticky-bar", SHTProductStickyBar);

if (!customElements.get("sht-gift-card-recipient-form")) {
  class SHTGiftCardRecipientForm extends HTMLElement {
    constructor() {
      super();
      this.i_want_input = this.querySelector(`.js-gift-card-recipient-form-i-want`);
      this.i_want_input.disabled = false;
      this.hidden_i_want_input = this.querySelector(`.js-gift-card-recipient-form-i-want-hidden`);
      this.hidden_i_want_input.disabled = true;
      this.email_input = this.querySelector(`.js-gift-card-recipient-form-email`);
      this.name_input = this.querySelector(`.js-gift-card-recipient-form-name`);
      this.message_input = this.querySelector(`.js-gift-card-recipient-form-message`);
      this.send_on_input = this.querySelector(`.js-gift-card-recipient-form-send_on`);
      this.email_error = this.querySelector(`.js-gift-card-recipient-form-email-error`);

      this.addEventListener("change", this.onChangeHandler.bind(this));
    }

    onChangeHandler() {
      if (!this.i_want_input.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }

    clearErrorMessage() {
      this.querySelectorAll(".js-gift-card-recipient-form-error").forEach(field => {
        field.classList.add("hidden");
        let textField = field.querySelector(".error-message");
        if (textField) textField.innerText = "";
      });

      [this.email_input, this.name_input, this.message_input, this.send_on_input].forEach(inputElement => {
        inputElement.setAttribute("aria-invalid", false);
        inputElement.removeAttribute("aria-describedby");
        inputElement.removeAttribute("tabindex");
      });
    }

    clearInputFields() {
      this.email_input.value = "";
      this.name_input.value = "";
      this.message_input.value = "";
      this.send_on_input.value = "";
    }

    handleErrorMessage(error, message) {
      Object.entries(error).forEach(([key, value]) => {
        let errorMessageContainer = this.querySelector(`.js-gift-card-recipient-form-${key}-error`);
        let errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
        let input = this.querySelector(`.js-gift-card-recipient-form-${key}`);
        errorMessageContainer.querySelector(".error-message").innerText = value;
        errorMessageContainer.classList.remove("hidden");
        input.setAttribute("aria-invalid", true);
        input.setAttribute("aria-describedby", errorMessageId);
        input.focus();
      });
    }

    resetRecipientForm() {
      if (this.i_want_input.checked) {
        this.i_want_input.checked = false;
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }
  }
  customElements.define("sht-gift-card-recipient-form", SHTGiftCardRecipientForm);
}

if (!customElements.get("sht-prd-variants-recom")) {
  class SHTProductRecommendationsVariants extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("sht-prd-variants-recom");
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.executeScriptElements(this);
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            typeof SHTElementLazyLoad !== "undefined" && new SHTElementLazyLoad();
          });
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }

    executeScriptElements(containerElement) {
      const scriptElements = containerElement.querySelectorAll("script");

      Array.from(scriptElements).forEach(scriptElement => {
        const clonedElement = document.createElement("script");

        Array.from(scriptElement.attributes).forEach(attribute => {
          clonedElement.setAttribute(attribute.name, attribute.value);
        });

        clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

        scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
      });

      while (SHTDefer.length) SHTDefer.shift().call();
    }
  }

  customElements.define("sht-prd-variants-recom", SHTProductRecommendationsVariants);
}

if (!customElements.get("sht-prd-desc-recom")) {
  class SHTProductRecommendationsDesc extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("sht-prd-desc-recom");
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.executeScriptElements(this);
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            typeof SHTElementLazyLoad !== "undefined" && new SHTElementLazyLoad();
          });
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }

    executeScriptElements(containerElement) {
      const scriptElements = containerElement.querySelectorAll("script");

      Array.from(scriptElements).forEach(scriptElement => {
        const clonedElement = document.createElement("script");

        Array.from(scriptElement.attributes).forEach(attribute => {
          clonedElement.setAttribute(attribute.name, attribute.value);
        });

        clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

        scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
      });

      while (SHTDefer.length) SHTDefer.shift().call();
    }
  }

  customElements.define("sht-prd-desc-recom", SHTProductRecommendationsDesc);
}

if (!customElements.get("sht-prd-spec-recom")) {
  class SHTProductRecommendationsSpec extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("sht-prd-spec-recom");
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.executeScriptElements(this);
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            typeof SHTElementLazyLoad !== "undefined" && new SHTElementLazyLoad();
          });
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }

    executeScriptElements(containerElement) {
      const scriptElements = containerElement.querySelectorAll("script");

      Array.from(scriptElements).forEach(scriptElement => {
        const clonedElement = document.createElement("script");

        Array.from(scriptElement.attributes).forEach(attribute => {
          clonedElement.setAttribute(attribute.name, attribute.value);
        });

        clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

        scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
      });

      while (SHTDefer.length) SHTDefer.shift().call();
    }
  }

  customElements.define("sht-prd-spec-recom", SHTProductRecommendationsSpec);
}

if (!customElements.get("sht-prd-view-recom")) {
  class SHTProductRecommendationsView extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("sht-prd-view-recom");
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.executeScriptElements(this);
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            typeof SHTElementLazyLoad !== "undefined" && new SHTElementLazyLoad();
          });
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }

    executeScriptElements(containerElement) {
      const scriptElements = containerElement.querySelectorAll("script");

      Array.from(scriptElements).forEach(scriptElement => {
        const clonedElement = document.createElement("script");

        Array.from(scriptElement.attributes).forEach(attribute => {
          clonedElement.setAttribute(attribute.name, attribute.value);
        });

        clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

        scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
      });

      while (SHTDefer.length) SHTDefer.shift().call();
    }
  }

  customElements.define("sht-prd-view-recom", SHTProductRecommendationsView);
}

class SHTMainProductComparisonVariantSelector extends SHTVariantSelector {
  constructor() {
    super();
  }
  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);

    this.elms = {
      radio_elms: this.$$(".js-featured-variant-radio-item"),
      form: SHTHelper.qs(`#mainproductComparisonForm-${this.dataset.section}-${this.dataset.block}`),
      price: SHTHelper.qs(`#mainproductComparisonPrice-${this.dataset.block}`),
      product_form: SHTHelper.qs(`sht-featured-prd-frm[data-section="${this.dataset.section}"]`),
      inventory_tracking: SHTHelper.qs(`#mainproductComparisonInventoryTracking-${this.dataset.block}`),
      variant_picker: SHTHelper.qs(`#productComparisonVariantPicker-${this.dataset.section}-${this.dataset.block}`),
      slideshow: SHTHelper.qs(`sht-prd-slideshow[data-block="${this.dataset.block}"]`),
      variant_options: this.$$(".js-variant-option-value"),
    };

    this.price_selector = `#mainproductComparisonPrice-${this.dataset.block}`;
    this.inventory_tracking_selector = `#mainproductComparisonInventoryTracking-${this.dataset.block}`;
    this.variant_picker_selector = `#productComparisonVariantPicker-${this.dataset.section}-${this.dataset.block}`;

    this.slideshow_selector = `sht-prd-slideshow[data-section="${this.dataset.section}"]`;

    this.variantData = this.setSelectedVariants(this);

    this.updateProductStickyInfo(this.variantData);
    this.updateSelectedVariants(this.variantData);
    this.bindEventHandlers();
  }

  setSelectedVariants(node) {
    return JSON.parse(node.querySelector('[data-selected-variant][type="application/json"]').textContent);
  }

  buildRequestUrlWithParams(url, optionValues) {
    const params = new URLSearchParams({ section_id: 'main-product-comparison' });
    if (optionValues.length) params.append("option_values", optionValues.join(","));
    return `${url}?${params.toString()}`;
  }

  setActiveMedia(variant) {
    if (variant.featured_media) {
      let mediaId = variant.featured_media.id;

      let activeMedia = this.elms.slideshow.querySelector(`sht-prd-comparison-itm[data-comparison="${this.dataset.block}-${mediaId}"]`);

      this.elms.slideshow.querySelectorAll(".js-product-slideshow-item").forEach(element => {
        element.classList.remove("d-block");
        this.elms.slideshow.hide_variant == "true" && element.classList.add("d-none");
      });

      this.elms.slideshow.querySelectorAll(".js-product-slideshow-thumb").forEach(element => {
        element.classList.remove("is-active-item");
      });

      activeMedia.classList.add("d-block");
      this.elms.slideshow.hide_variant == "true" && activeMedia.classList.remove("d-none");

      this.elms.slideshow.pauseAllVideo();
    }
  }
}

class SHTMainProductComparisonVariantRadios extends SHTMainProductComparisonVariantSelector {
  constructor() {
    super();
    this.connectedCallback();
  }

  connectedCallback() {
    setTimeout(() => this.init(), 1000);
  }
}
customElements.define("sht-main-product-comparison-variant-radios", SHTMainProductComparisonVariantRadios);